import type { TriggersAndReactionsRefs } from './types'
import { getPageFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'triggersAndReactions'
const triggersAndReactionsSiteRefProvider = getPageFeatureBoundRefProvider(featureName)

const triggersAndReactionsRefs: TriggersAndReactionsRefs = {
	applyEffects: () => triggersAndReactionsSiteRefProvider(['applyEffects']),
	removeEffects: () => triggersAndReactionsSiteRefProvider(['removeEffects']),
	observeChildListChange: () => triggersAndReactionsSiteRefProvider(['observeChildListChange']),
	observeChildListChangeMaster: () => triggersAndReactionsSiteRefProvider(['observeChildListChangeMaster']),
}
export { triggersAndReactionsRefs }
